import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { ChangeSecurityQuestions } from './../model/change-security-questions';
import { ChangeSecurityQuestionsEventType } from './../change-security-questions.event.type';

@Component({
	selector: 'app-change-questions-result',
	templateUrl: './change-questions-result.component.html',
	styleUrls: ['./change-questions-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ChangeQuestionsResultComponent implements OnInit, OnDestroy {

	@Input() changeQuestionsData: ChangeSecurityQuestions;
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();
	private view = '[data-component="change-questions-result"]';
	public active = false;

	constructor() { }

	ngOnInit() {
		AppEventDispatcher.listen(ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS_RESULT, data => {

			if (data.show) {
				this.active = true;
				this.show();

				this.showStepButtons.emit(true);
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS_RESULT);
	}

	show() {

		AppEventDispatcher.dispatch(ChangeSecurityQuestionsEventType.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-security-questions/change-questions-result/change-questions-result.component.ts